module.exports = __webpack_public_path__ + "img/type_poster_2.bf83edf9.png";